module.exports = __webpack_public_path__ + "media/images/new/icons/cellphone-eff31dcc6fbda1ef5ea02d9b3f4addfe.png";